/*  see styleguide for usage */

var toolTips = function () { 	
	let init = function(){
		document.querySelectorAll(".tooltipTrigger").forEach(tip => {
			tip.removeEventListener("click", toggleTip);
			tip.addEventListener("click", toggleTip);
			
			tip.removeEventListener("blur", closeTip);
			tip.addEventListener("blur", closeTip);
		});
	},
	initSingleElem = function(elem) {
		elem.removeEventListener("click", toggleTip);
		elem.addEventListener("click", toggleTip);
		
		elem.removeEventListener("blur", closeTip);
		elem.addEventListener("blur", closeTip);
	},
	toggleTip = function(e){
		e.preventDefault();
		let el = e.currentTarget;
		if(el.nextElementSibling.className == "visible") closeTip();
		else showTip(el);
	},  
	showTip = function(tipToShow){
		tipToShow.classList.add("activeTip");
		tipToShow.setAttribute("aria-expanded", "true");
		tipToShow.nextElementSibling.classList.add("visible");
		tipToShow.nextElementSibling.setAttribute("aria-hidden", "false");
		
		document.addEventListener('click', hideOnClickOutside);
		document.addEventListener('touchstart', hideOnClickOutside);
		document.addEventListener("keyup", escapeTip);
	},
	closeTip = function(){
		let activeTip = document.querySelector(".activeTip") ? document.querySelector(".activeTip") : null;
		
		document.removeEventListener('click', hideOnClickOutside);
		document.removeEventListener('touchstart', hideOnClickOutside);
		document.removeEventListener("keyup", escapeTip);
		
		if(activeTip !== null){
			activeTip.classList.remove("activeTip");
			activeTip.setAttribute("aria-expanded", "false");
			activeTip.nextElementSibling.classList.remove("visible");
			activeTip.nextElementSibling.setAttribute("aria-hidden", "true"); 
		}
	},
	hideOnClickOutside = function(e){
		let activeTip = document.querySelector(".activeTip");
		if (activeTip) {
		    if (!activeTip.contains(e.target)) closeTip();
		}
	},
	escapeTip = function(e){
		if((e.which || e.keyCode) === 27) closeTip();
	};
	return {
		init: init,
		initSingleElem: initSingleElem
	};
};